import getConfig from "next/config";
import Head from "next/head";

import React from "react";

export default function OneTap(): JSX.Element {
  const {publicRuntimeConfig} = getConfig();

  return (
    <div>
      <Head>
        <script src="https://accounts.google.com/gsi/client" async defer />
      </Head>
      <div
        id="g_id_onload"
        data-client_id={publicRuntimeConfig.DATA_CLIENT_ID}
        data-auto_select="true"
        data-cancel_on_tap_outside="true"
      />
    </div>
  );
}
